<template>
  <div class="alert">
    <div class="alert-decorative-bar"></div>
    <h4 class="alert-heading">
      {{ heading }}
    </h4>
    <div class="alert-text">
      {{ text }}
    </div>
    <div class="alert-button-bar" v-if="confirmLabel || cancelLabel">
      <button class="primary-button" @click="handleConfirm" v-if="confirmLabel">
        {{ confirmLabel }}</button
      ><button class="ghost-button" @click="handleCancel" v-if="cancelLabel">
        {{ cancelLabel }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Alert",
  props: {
    handleCancel: {
      type: Function,
      required: false,
      default: () => {},
    },
    cancelLabel: {
      type: String,
      required: false,
      default: "",
    },
    confirmLabel: {
      type: String,
      required: false,
      default: "",
    },
    handleConfirm: {
      type: Function,
      required: false,
      default: () => {},
    },
    text: {
      type: String,
      required: true,
      default: "",
    },
    heading: {
      type: String,
      required: true,
      default: "",
    },
  },
};
</script>

<style scoped>
.alert-decorative-bar {
  left: -1px;
  top: 0px;
  position: absolute;
  display: flex;
  width: 8px;
  min-height: 100%;
  margin: 0px 0px 0px 1px;
  background: rgb(18, 40, 87);
  line-height: 1em;
}

.alert {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  margin: 0px;
  padding: 20px 20px 20px 30px;
  background: rgb(240, 244, 246);
  border: 1px solid rgba(18, 40, 87, 0.04);
  border-radius: 10px;
  font-family: "Roboto", sans-serif;
  line-height: 1em;
  color: rgb(75, 75, 75);
  overflow: hidden;
}

.alert-text {
  margin: 0px;
  line-height: 1.25em;
  color: #122857;
}

.alert-heading {
  margin: 0px 0px 15px 1px;
  font-size: 20px;
  line-height: 1em;
  font-weight: 800;
  color: #122857;
}

.alert-button-bar {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  width: 911px;
  margin: 30px 0px 0px 0px;
  line-height: 1em;
}

.primary-button {
  padding: 2px 20px;
  font-family: inherit;
  min-height: 30px;
  margin: 0px;
  background: rgb(18, 40, 87);
  border: 1px none black;
  border-radius: 25px;
  transition: background 0.25s ease-in-out;
  font-size: 15px;
  line-height: 1em;
  color: white;
}

.ghost-button {
  font-family: inherit;
  min-height: 30px;
  padding: 2px 20px;
  margin: 0px 0px 0px 10px;
  background: rgba(0, 0, 0, 0);
  border: 1px solid rgb(214, 219, 228);
  border-radius: 25px;
  transition: background 0.25s ease-in-out;
  font-size: 15px;
  line-height: 1em;
  color: #122857;
}
</style>
